import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { WatchList } from '../../models/WatchList';
import { deleteWatchList } from '../../services/watchLists/watchLists.service';
import { Channels } from '../../utils/channels';
import { queryKeys } from '../queryKeyFactory';
import { invalidateFeedQueries } from '../../utils/invalidateFeedQueries';

export default (): UseMutationResult<void, void, string, { previousWatchLists: WatchList[] }> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (id: string) => {
      await deleteWatchList(id);
    },
    {
      onSuccess: (_, id) => {
        const previousWatchLists = queryClient.getQueryData<WatchList[]>([queryKeys.fetchWatchlists.all])!;
        const updatedWatchlistLists = previousWatchLists.filter((deletedWatchlist) => deletedWatchlist.id !== id);

        queryClient.setQueryData([queryKeys.fetchWatchlists.all], updatedWatchlistLists);
        Channels.watchlistsChannel.postMessage(null);
        invalidateFeedQueries(queryClient);
      },
    }
  );
};
